import { render } from "./HospitalAdTable.vue?vue&type=template&id=4414b762&scoped=true"
import script from "./HospitalAdTable.vue?vue&type=script&lang=js"
export * from "./HospitalAdTable.vue?vue&type=script&lang=js"

import "./HospitalAdTable.vue?vue&type=style&index=0&id=4414b762&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4414b762"]])

export default __exports__